import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { generateAlternateLinks, generateTitleAndMetaTags } from 'src/utils/seo'

const SeoStore = ({ title, description }) => {
  const [storePath, setStorePath] = useState()

  const updateRoute = (event) => {
    setStorePath(event.detail)
  }

  useEffect(() => {
    window.addEventListener('storeRouteUpdated', updateRoute)
    return () => {
      window.removeEventListener('storeRouteUpdated', updateRoute)
    }
  }, [])

  return (
    <Helmet>
      {generateTitleAndMetaTags(title, description)}
      {generateAlternateLinks(storePath)}
      <script type='application/ld+json'>
        {`{
          "@context": "https://schema.org/", 
          "@type": "BreadcrumbList", 
          "itemListElement": [{
            "@type": "ListItem", 
            "position": 1, 
            "name": "Gemvision Store",
            "item": "https://gemvision.com/store"  
          }]
        }`}
      </script>
    </Helmet>
  )
}

export default React.memo(SeoStore)
